import { render, staticRenderFns } from "./BoltScene.vue?vue&type=template&id=3b20d51e&scoped=true"
import script from "./BoltScene.vue?vue&type=script&lang=js"
export * from "./BoltScene.vue?vue&type=script&lang=js"
import style0 from "./BoltScene.vue?vue&type=style&index=0&id=3b20d51e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b20d51e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
